module.exports = __webpack_public_path__ + "media/en_us_s1_Beckie.7b23f869.mp3";